export default __webpack_public_path__ + "static/media/undergraduate-glyph-16px.a079fe91.svg";